export const initCloseNavOnClick = () => {
  const navCollapse = document.querySelector('#mainNav');
  const navLinks = navCollapse?.querySelectorAll('.nav-link, .dropdown-item, .site-header__mega-list a, .site-header__drawer-utility a');

  if (!navCollapse || !navLinks?.length || window.matchMedia('(min-width: 992px)').matches) {
    return;
  }

  navLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const collapseInstance = window.bootstrap?.Collapse.getOrCreateInstance(navCollapse);
      collapseInstance.hide();
    });
  });
};